const Skeleton = ({ className = '', variant = 'text' }) => {
  const baseStyles = 'animate-pulse bg-gray-200 rounded'
  
  const variants = {
    text: 'h-4',
    heading: 'h-6',
    avatar: 'rounded-full',
    card: 'h-32',
    button: 'h-10 w-24',
  }
  
  return <div className={`${baseStyles} ${variants[variant]} ${className}`} />
}

export default Skeleton

